export function assert(value: unknown, message?: string): asserts value {
  if (typeof value === 'undefined' || value === null) {
    throw new Error(message ?? 'Expected non-null value was null');
  }
}

export function assertTrue(value: boolean, message?: string): asserts value {
  if (!value) {
    throw new Error(message ?? 'Expected true value was false');
  }
}

